/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1435
 */

var r = require(/* 993 */"./993")
module.exports = function (e) {
  return "function" == typeof e ? e : r
}
